<template>
  <div class="outer-list">
    <h3 class="mb-2">News</h3>
    <div class="list">
      <NewsCard
        v-for="news in list.news"
        :key="news"
        :url="S3BaseUrl+news"
        @card_updated="deleteCardHandler()"
      />
    </div>

    <h3 class="mt-4 mb-2">Tutorials</h3>
    <div class="list">
      <NewsCard
        v-for="news in list.tutorials"
        :key="news"
        :url="S3BaseUrl+news"
        @card_updated="deleteCardHandler()"
      />
    </div>
  </div>
</template>

<script setup>
import {
  onMounted, ref,
} from 'vue';
import NewsCard from '@/components/News/NewsCard.vue';

const S3BaseUrl = 'https://studio-news.s3.ca-central-1.amazonaws.com/';

const list = ref({});

onMounted(() => {
  GetNewsList();
});

async function GetNewsList() {
  const url = `${S3BaseUrl}list.json?cacheBust=${Date.now()}`;
  const response = await fetch(url, { cache: "no-store" });
  list.value = await response.json();
}

</script>

<style lang="scss" scoped>

.outer-list {
  flex: 1 1 auto;
  min-width: 100px;
  padding: 10px;
}

@media (min-width: $breakpoint-lg) {
  .outer-list {
    max-width: 40%;
  }
}

.list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

</style>
